export function prettifyCategoryFilter() {
    const prettify = (val: string): string => {
        val = val.replace(new RegExp("_", "gm"), " ");
        val = val.replace(new RegExp("~", "gm"), " > ");
        return val;
    };
    return (
        name: string,
        specials: Record<string, string | boolean> | null = null,
        na: string | null = null,
    ): string | null => {
        if (name && specials) {
            const className = specials[name.toString().toLowerCase()];

            if (className) {
                return (
                    '<span class="' +
                    (className === true ? "cat-" + name.toLowerCase().replace(/\s/gi, "_") : className) +
                    '">' +
                    prettify(name) +
                    "</span>"
                );
            }
        }

        return name ? prettify(name) : na;
    };
}
